import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import animationData from '../assets/yyz-gift.json';
import './styles/GiftBox.css';

const GiftBox = ({ isOpen, onClick }) => {
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!containerRef.current) return;

    animationRef.current = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData,
    });

    animationRef.current.goToAndStop(0, true);

    return () => {
      animationRef.current?.destroy();
      animationRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!animationRef.current) return;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (isOpen) {
      animationRef.current.setDirection(1);
      animationRef.current.play();
    } else {
      animationRef.current.setDirection(-1);
      animationRef.current.play();
    }
  }, [isOpen]);

  return (
    <div className="gift-box-wrapper" onClick={onClick} aria-label="Gift Box">
      <div className={`gift-box ${isOpen ? 'open' : ''}`}>
        <div id="bodymovin" ref={containerRef} />
      </div>
    </div>
  );
};

export default GiftBox;
